import React, { FC } from "react";
import { createUseStyles, useTheme } from "react-jss";
import styles from "./styles";

interface Props {
  currentView: string;
  changeView: (view: string) => void;
  searchbarOption: string;
  handleKeyDown: (event: React.KeyboardEvent, view: string) => void;
}

const MapSwitcher: FC<Props> = (props: Props) => {
  const useStyles = createUseStyles(styles);
  const theme = useTheme();

  const classes = useStyles({
    theme,
    ...props,
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { currentView, changeView, searchbarOption } = props;

  return (
    <div className={classes.container} data-testid="mapswitcher">
      <div
        className={classes.campusMap}
        onClick={() => changeView("campusmap")}
        // eslint-disable-next-line react/destructuring-assignment
        onKeyDown={(event) => props.handleKeyDown(event, "campusmap")}
        role="button"
        tabIndex={0}
        data-testid="campusmap"
      >
        Campus Map
      </div>
      <div
        className={classes.mapView}
        onClick={() => changeView("mapview")}
        // eslint-disable-next-line react/destructuring-assignment
        onKeyDown={(event) => props.handleKeyDown(event, "mapview")}
        role="button"
        tabIndex={0}
        data-testid="mapview"
      >
        Google Map
      </div>
    </div>
  );
};

export default MapSwitcher;
